// There is a bug in Vue when using teleports/portals and scoped styles
// This workaround is useful to put the correct scope on the component
// https://github.com/vuejs/core/issues/2669

import { getCurrentInstance } from "vue";

export function useComponentScope() {
  const scope = getCurrentInstance()?.vnode.scopeId ?? "";

  return { scope };
}
